import SectionHeading from './SectionHeading'
import DataIcon from '../../Icons/roofers/choose-olm/data-icon.svg'
import QRCodeIcon from '../../Icons/roofers/choose-olm/qr-code-icon.svg'
import CallIcon from '../../Icons/roofers/choose-olm/call-icon.svg'
import TimeIcon from '../../Icons/roofers/choose-olm/time-icon.svg'
import SupportIcon from '../../Icons/roofers/choose-olm/support-icon.svg'
import SpeakerIcon from '../../Icons/roofers/choose-olm/speaker-icon.svg'

const defaultHeading = {
    pre: 'Why ',
    highlight: 'Roofers',
    post: ' Choose Open Letter Marketing',
}

const defaultItems = [
    {
        title: 'Hyper <br> Targeted Data',
        body: 'We’ll find qualified, highly targeted lists of homeowners most likely to need roofing services.',
        variant: 'accent',
        icon: DataIcon,
    },
    {
        title: 'Unique Trackable QR Codes',
        body: 'With real-time insights, you’ll know which homeowners are engaging with your offer',
        variant: 'neutral',
        icon: QRCodeIcon,
    },
    {
        title: 'Call <br> Tracking',
        body: 'Pull a phone number dedicated to your campaign, so you’ll know how many jobs your mailers generated.',
        variant: 'accent',
        icon: CallIcon,
    },
    {
        title: '2-Day Turnaround Time',
        body: 'Speed to lead is everything after a storm—your campaign goes out fast.',
        variant: 'neutral',
        icon: TimeIcon,
    },
    {
        title: 'One-on-One Support',
        body: 'A dedicated Marketing Coach helps with design, messaging, and data strategy.',
        variant: 'accent',
        icon: SupportIcon,
    },
    {
        title: 'Automated Multi-Touch Campaigns',
        body: 'Stay top-of-mind with sequences of postcards, letters, and follow-ups that convert.',
        variant: 'neutral',
        icon: SpeakerIcon,
    },
]

const defaultEdges = {
    topLeft: {
        src: '/assets/roofers/roofers-edge-1.png',
        alt: 'Sample postcard top-left',
    },
    bottomRight: {
        src: '/assets/roofers/roofers-edge-2.png',
        alt: 'Sample postcard bottom-right',
    },
}

function BenefitCard({ title, body, Icon, variant = 'neutral' }) {
    const isAccent = variant === 'accent'
    return (
        <div
            className={[
                'relative',
                'rounded-2xl',
                'shadow-xl',
                'transition-transform',
                'bg-white',
                isAccent
                    ? 'bg-[linear-gradient(305.62deg,#FAB132_0%,#F15A22_97.83%)] text-white'
                    : 'bg-white text-olm-new-black',
            ].join(' ')}>
            <span className="absolute -top-[50px] left-0 right-0 mx-auto w-[120px] h-[120px]">
                <Icon />
            </span>
            {/* Inner padding wrapper so the shadow remains outside */}
            <div className="py-6 sm:py-7">
                <div
                    className={[
                        'px-6 sm:px-7',
                        'text-center font-bold',
                        'text-lg sm:text-2xl',
                        'pt-5',
                        isAccent ? 'text-white' : 'text-olm-new-black',
                    ].join(' ')}
                    dangerouslySetInnerHTML={{
                        __html: title,
                    }}></div>

                {/* Divider */}
                <div
                    className={[
                        'mt-3 mb-4 h-px',
                        isAccent ? 'bg-white/80' : 'bg-gray-300',
                    ].join(' ')}
                />

                <p
                    className={[
                        'px-6 sm:px-7',
                        'text-center leading-relaxed',
                        'text-base sm:text-xl',
                        isAccent ? 'text-white' : 'text-olm-black',
                    ].join(' ')}
                    dangerouslySetInnerHTML={{
                        __html: body,
                    }}></p>
            </div>
        </div>
    )
}

export default function WhyChooseOLM(props) {
    const heading = props?.heading || defaultHeading
    const items =
        Array.isArray(props?.items) && props.items.length > 0
            ? props.items
            : defaultItems
    const edges = props?.edges || defaultEdges

    return (
        <section className="relative my-0 z-20 overflow-visible bg-[linear-gradient(180deg,#FAFAFA_0%,#FFF8EA_100%)]">
            {/* Decorative edge image: top-left */}
            <div className="hidden lg:block absolute top-6 -left-3 z-0">
                <img
                    src={edges.topLeft?.src}
                    alt={edges.topLeft?.alt || 'Decorative postcard'}
                    className="w-full h-auto drop-shadow-2xl"
                />
            </div>

            {/* Decorative edge image: bottom-right */}
            <div className="hidden lg:block absolute -bottom-14 right-0 z-30 pointer-events-none">
                <img
                    src={edges.bottomRight?.src}
                    alt={edges.bottomRight?.alt || 'Decorative postcard'}
                    className="w-full h-auto drop-shadow-2xl"
                />
            </div>

            <div className="relative z-10 container mx-auto px-4 py-14 sm:py-16 lg:py-20">
                <div className="max-w-2xl mx-auto">
                    <SectionHeading>
                        {heading.pre}
                        <span className="text-olm">{heading.highlight}</span>
                        {heading.post}
                    </SectionHeading>
                </div>

                <div className="mt-10 sm:mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 gap-y-20 lg:gap-y-20 lg:gap-8 max-w-5xl mx-auto">
                    {items.map((item, idx) => (
                        <BenefitCard
                            key={`${item.title}-${idx}`}
                            title={item.title}
                            body={item.body}
                            Icon={item.icon}
                            variant={item.variant}
                        />
                    ))}
                </div>
            </div>
        </section>
    )
}
